import { getNewAccessToken } from "api/common/Auth.api";
import { getCookie, setCookie, removeCookie, getJwtKey, getJwtRefreshKey, getAgencyIdKey } from "./Cookie.helper";

const accessTokenKey: string = getJwtKey();
const refreshTokenKey: string = getJwtRefreshKey();
const agencyTokenKey: string = getAgencyIdKey();

export const getAccessToken = (): string => {
    return getCookie(accessTokenKey);
};

export const getRefreshToken = (): string => {
    return getCookie(refreshTokenKey);
};

export const setAccessToken = (accessToken: string): void => {
    setCookie(accessTokenKey, accessToken, null);
};

export const setRefreshToken = (refreshToken: string): void => {
    setCookie(refreshTokenKey, refreshToken, null);
};

export const removeAuthTokens = (): void => {
    console.log("helpers/Auth.helper.tsx::removeAuthTokens");
    console.log({ accessTokenKey, refreshTokenKey });
    removeCookie(accessTokenKey);
    removeCookie(refreshTokenKey);
};

export const getAgencyId = (): string => {
    return getCookie(agencyTokenKey);
};

export const setAgencyId = (agencyId: string) => {
    setCookie(agencyTokenKey, agencyId, null);
};

export const removeAgencyId = (): void => {
    removeCookie(agencyTokenKey);
};

export const getNewAccessTokenValue = async () => {
    const refreshTokenParams = {
        accessToken: getAccessToken(),
        refreshToken: getRefreshToken(),
    };

    const { data }: any = await getNewAccessToken(refreshTokenParams);

    const { jwtToken, refreshToken } = data.data;

    console.log("Access token refreshed successfully");

    // 새로운 토큰 저장
    setAccessToken(jwtToken);
    setRefreshToken(refreshToken);

    return jwtToken;
}
